import React from 'react'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import formModel from 'containers/Onboarding/FormModels/Models';
import { useFormikContext, FieldArray } from 'formik'
import dataStorage from 'dataStorage';
import {
    SelectField,
    InputField,
    BooleanRadio,
    FileUpload,
    AutocompleteField
} from 'components/CustomFields'
import {
    TAX_ID_REASON,
    TAX_ID_REASON_OPTIONS,
    BOOLEAN_OPTIONS
} from 'constants/Options/options'
import { Trans } from 'react-i18next'
import ListCountry from 'constants/Countries/countries'
import useStyles from 'containers/Onboarding/styles'
import {
    EMPTY_TAX_RESIDENCY
} from 'constants/constants'
import { clone } from 'helpers/utils'

const { formField } = formModel

const countries = [
    { code: 'CN', value: 'CHN', label: 'China', phone: '86' },
    { code: 'US', value: 'USA', label: 'United States', phone: '1' },
    { code: 'HK', value: 'HKG', label: 'Hong Kong', phone: '852' },
    { code: 'AU', value: 'AUS', label: 'Australia', phone: '61' },
    { code: 'AT', value: 'AUT', label: 'Austria', phone: '43' },
    { code: 'BE', value: 'BEL', label: 'Belgium', phone: '32' },
    { code: 'CA', value: 'CAD', label: 'Canada', phone: '1' },
    { code: 'IE', value: 'IRL', label: 'Ireland', phone: '353' },
    { code: 'IL', value: 'ISR', label: 'Israel', phone: '972' },
    { code: 'IT', value: 'ITA', label: 'Italy', phone: '39' },
    { code: 'NO', value: 'NOR', label: 'Norway', phone: '47' },
    { code: 'PT', value: 'PRT', label: 'Portugal', phone: '351' },
    { code: 'SG', value: 'SGP', label: 'Singapore', phone: '65' },
    { code: 'ES', value: 'ESP', label: 'Spain', phone: '34' },
    { code: 'SE', value: 'SWE', label: 'Sweden', phone: '46' },
    { code: 'CH', value: 'CHE', label: 'Switzerland', phone: '41' },
    { code: 'GB', value: 'GBR', label: 'United Kingdom', phone: '44' }
];

const OtherIdentityDisclosuresAndTaxInformation = () => {
    const classes = useStyles()
    const { values } = useFormikContext();

    const renderTaxInformation = () => {
        return (
            <FieldArray
                name={formField.tax_information.name}
                render={arrayHelpers => (
                    <React.Fragment>
                        {
                            values.tax_information.map((e, i) => (
                                <Grid container spacing={3} key={`tax_information_${i}`} className={classes.boxContainer}>
                                    {
                                        values.tax_information.length > 1
                                            ? <IconButton
                                                className={classes.removeArrBtn}
                                                onClick={() => arrayHelpers.remove(i)}>
                                                <RemoveIcon />
                                            </IconButton>
                                            : <React.Fragment />
                                    }
                                    <Grid item xs={12}>
                                        <Typography variant='subtitle2'><Trans values={{ index: i + 1 }}>lang_tax_residency_with_index</Trans></Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AutocompleteField
                                            required
                                            name={`tax_information[${i}].tax_country`}
                                            label={formField.tax_information.tax_country.label}
                                            data={countries}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <BooleanRadio
                                            isHorizontal
                                            name={`tax_information[${i}].is_there_taxid`}
                                            label={formField.tax_information.is_there_taxid.label}
                                            data={BOOLEAN_OPTIONS}
                                            fullWidth
                                        />
                                    </Grid>
                                    {
                                        e.is_there_taxid
                                            ? <Grid item xs={12}>
                                                <InputField
                                                    required
                                                    maxLength={15}
                                                    textTransform='uppercase'
                                                    name={`tax_information[${i}].tax_id`}
                                                    label={formField.tax_information.tax_id.label}
                                                    fullWidth
                                                />
                                            </Grid>
                                            : <React.Fragment>
                                                <Grid item xs={12}>
                                                    <SelectField
                                                        required
                                                        name={`tax_information[${i}].taxid_reason`}
                                                        label={formField.tax_information.taxid_reason.label}
                                                        data={TAX_ID_REASON_OPTIONS}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                {
                                                    e.taxid_reason === TAX_ID_REASON.REASON_B
                                                        ? <Grid item xs={12}>
                                                            <InputField
                                                                required
                                                                maxLength={300}
                                                                name={`tax_information[${i}].taxid_reason_desc`}
                                                                label={formField.tax_information.taxid_reason_desc.label}
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        : <React.Fragment />
                                                }
                                            </React.Fragment>
                                    }
                                </Grid>
                            ))
                        }
                        <Button variant='text'
                            className={classes.addArrBtn}
                            onClick={() => arrayHelpers.push(clone(EMPTY_TAX_RESIDENCY))}
                        >
                            <Trans>lang_add_another_tax_residency</Trans>
                        </Button>
                    </React.Fragment>
                )}
            />
        )
    }

    const renderUSPersonInfo = () => {
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <BooleanRadio
                        isHorizontal
                        name={formField.us_person_info.are_you_us_person.name}
                        label={formField.us_person_info.are_you_us_person.label}
                        data={BOOLEAN_OPTIONS}
                        fullWidth
                    />
                </Grid>
                {
                    values.us_person_info.are_you_us_person
                        ? <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={9}
                                helperText={'lang_note_tin_when_is_us_person'}
                                name={formField.us_person_info.taxpayer_id.name}
                                label={formField.us_person_info.taxpayer_id.label}
                                fullWidth
                            />
                        </Grid>
                        : <React.Fragment>
                            <Grid item xs={12}>
                                <AutocompleteField
                                    required
                                    name={formField.us_person_info.country_of_citizenship.name}
                                    label={formField.us_person_info.country_of_citizenship.label}
                                    data={ListCountry}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AutocompleteField
                                    required
                                    name={formField.us_person_info.country_of_tax_treaty_benefits.name}
                                    label={formField.us_person_info.country_of_tax_treaty_benefits.label}
                                    data={ListCountry}
                                    fullWidth
                                />
                            </Grid>
                        </React.Fragment>
                }
            </React.Fragment>
        )
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <BooleanRadio
                    isHorizontal
                    name={formField.identity_disclosure.acting_as_intermediary.name}
                    label={formField.identity_disclosure.acting_as_intermediary.label}
                    data={BOOLEAN_OPTIONS}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12}>
                <BooleanRadio
                    isHorizontal
                    name={formField.identity_disclosure.registered_securities_futures.name}
                    label={formField.identity_disclosure.registered_securities_futures.label}
                    data={BOOLEAN_OPTIONS}
                    fullWidth
                />
            </Grid>
            {
                values.identity_disclosure.registered_securities_futures
                    ? <React.Fragment>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={200}
                                name={formField.identity_disclosure.licensed_person_comp_name.name}
                                label={formField.identity_disclosure.licensed_person_comp_name.label}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FileUpload
                                required
                                name={formField.identity_disclosure.upload_consent_letter.name}
                                label={formField.identity_disclosure.upload_consent_letter.label}
                            />
                        </Grid>
                    </React.Fragment>
                    : <React.Fragment />
            }
            <Grid item xs={12}>
                <BooleanRadio
                    isHorizontal
                    name={formField.identity_disclosure.related_to_public_function.name}
                    label={formField.identity_disclosure.related_to_public_function.label}
                    data={BOOLEAN_OPTIONS}
                    fullWidth
                />
            </Grid>
            {
                values.identity_disclosure.related_to_public_function
                    ? <Grid item xs={12}>
                        <InputField
                            required
                            maxLength={300}
                            name={formField.identity_disclosure.relationship_desc.name}
                            label={formField.identity_disclosure.relationship_desc.label}
                            fullWidth
                        />
                    </Grid>
                    : <React.Fragment />
            }
            <Grid item xs={12}>
                <BooleanRadio
                    isHorizontal
                    name={formField.identity_disclosure.related_to_magpie.name}
                    label={formField.identity_disclosure.related_to_magpie.label}
                    data={BOOLEAN_OPTIONS}
                    fullWidth
                />
            </Grid>
            {
                values.identity_disclosure.related_to_magpie
                    ? <React.Fragment>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={100}
                                name={formField.identity_disclosure.comp_officer_name.name}
                                label={formField.identity_disclosure.comp_officer_name.label}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={300}
                                name={formField.identity_disclosure.comp_officer_relationship.name}
                                label={formField.identity_disclosure.comp_officer_relationship.label}
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>
                    : <React.Fragment />
            }
            <Grid item xs={12}>
                <BooleanRadio
                    isHorizontal
                    name={formField.identity_disclosure.spouse_margin.name}
                    label={formField.identity_disclosure.spouse_margin.label}
                    data={BOOLEAN_OPTIONS}
                    fullWidth
                />
            </Grid>
            {
                values.identity_disclosure.spouse_margin
                    ? <React.Fragment>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={100}
                                name={formField.identity_disclosure.spouse_name.name}
                                label={formField.identity_disclosure.spouse_name.label}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={20}
                                name={formField.identity_disclosure.spouse_account_number.name}
                                label={formField.identity_disclosure.spouse_account_number.label}
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>
                    : <React.Fragment />
            }
            <Grid item xs={12}>
                <BooleanRadio
                    isHorizontal
                    name={formField.identity_disclosure.control_magpie_voting.name}
                    label={formField.identity_disclosure.control_magpie_voting.label}
                    data={BOOLEAN_OPTIONS}
                    fullWidth
                />
            </Grid>
            {
                values.identity_disclosure.control_magpie_voting
                    ? <React.Fragment>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={100}
                                name={formField.identity_disclosure.client_name.name}
                                label={formField.identity_disclosure.client_name.label}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={20}
                                name={formField.identity_disclosure.client_account_number.name}
                                label={formField.identity_disclosure.client_account_number.label}
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>
                    : <React.Fragment />
            }
            {renderTaxInformation()}
            {renderUSPersonInfo()}
        </Grid>
    )
}

export default OtherIdentityDisclosuresAndTaxInformation